import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./stage-area.css";
import { withRouter, RouteComponentProps } from "react-router";
import { useEffect } from "react";
import { LOCAL_STORAGE_CHECKOUT } from "ui/constants";

const cx = cn.bind(styles);

const areaCss = (
    withBackground: boolean,
    withBackgroundColor: boolean,
    withHeightAuto: boolean,
) =>
    cx({
        stage: true,
        stageWithbackground: withBackground,
        stageWithBackgroundColor: withBackgroundColor,
        stageHeightAuto: withHeightAuto,
    });

const StageArea: React.SFC<RouteComponentProps> = ({ children, location }) => {
    useEffect(() => {
        if (localStorage.getItem(LOCAL_STORAGE_CHECKOUT)) {
            localStorage.removeItem(LOCAL_STORAGE_CHECKOUT);
        }
    }, []);

    return (
        <div
            className={areaCss(
                location.pathname.startsWith("/calendar/5"),
                !location.pathname.startsWith("/calendar/5"),
                location.pathname.startsWith("/calendar/4"),
            )}>
            {children}
        </div>
    );
};

export default withRouter(StageArea);
